export const en = {
  app: {
    name: 'Customise',
    brand: 'Besbello',
    loading: 'Loading...',
    retry: 'Retry',
    dismiss: "Dismiss",
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    delete: 'Delete',
    search: 'Search',
    error: 'Something went wrong',
    offline: 'Offline. Changes are saved when the connection returns.',
  },
  nav: {
    catalog: 'Catalogue',
    myOrders: 'My orders',
    account: 'My account',
    admin: 'Administration',
    login: 'Sign in with Besbello',
    loginLocal: 'Sign in',
    logout: 'Sign out',
  },
  catalog: {
    title: 'Choose your product',
    subtitle: 'T-shirts, hoodies, caps and mugs to customise.',
    searchPlaceholder: 'Search by name or reference',
    family: {
      all: 'All',
      tshirt: 'T-shirts',
      sweatshirt: 'Hoodies',
      cap: 'Caps',
      mug: 'Mugs',
      bag: 'Bags',
      other: 'Other',
    },
    colors: '{count} colours',
    empty: 'No products match those filters.',
    noPrice: 'No price loaded',
    notCustomizable: 'No print area yet',
    personalize: 'Customise',
  },
  product: {
    chooseColor: 'Colour',
    chooseZone: 'Print area',
    chooseTechnique: 'Technique',
    chooseSize: 'Reference size',
    zoneNote: 'The print area changes with the size: the design adapts.',
    start: 'Start designing',
    material: 'Composition',
    provenance: {
      inherited: 'Area inherited from the pattern',
      adjusted: 'Area adjusted for this product',
      exception: 'Area with an open exception',
    },
    confidence: 'Confidence {value}%',
    notCalibrated: 'This product has no print area yet',
    notCalibratedHelp: 'It still needs calibrating. Write to us and we will prepare the design for you.',
  },
  editor: {
    shareReady: "Read-only link. Valid for 7 days.",
    share: "Share",
    title: 'Editor',
    addImage: 'Image',
    addText: 'Text',
    addShape: 'Shape',
    maxSize: "This image prints well up to {w} × {h} mm at {dpi} dpi.",
    fitToMax: "Fit to {w} mm wide",
    removeBackground: "Remove background",
    vectorize: "Vectorize",
    crop: "Crop",
    crop_libre: "Original",
    crop_cuadrado: "Square",
    crop_apaisado: "Landscape",
    crop_vertical: "Portrait",
    imageMode: "Treatment",
    mode_ninguno: "As is",
    mode_grises: "Grayscale",
    mode_contrasteAlto: "High contrast",
    mode_unaTinta: "Single ink",
    brightness: "Brightness",
    contrast: "Contrast",
    saturation: "Saturation",
    threshold: "Threshold",
    noImagesYet: "You have not uploaded any images yet.",
    reuseThis: "Use this image",
    adjustFit: "Adjust where the print falls",
    adjustFitHelp: "Drag the box over the photo. It affects every design of this product.",
    mmPerPixel: "mm per pixel",
    rotateZone: "Rotate the zone to {ancho} × {alto} mm",
    saveFit: "Save the fit",
    fitSaved: "Fit saved and confirmed.",
    fix_resize: "Shrink to {valor} mm wide",
    fix_moveInside: "Move inside the zone",
    fix_thickenStroke: "Thicken the stroke to {valor} mm",
    fix_growText: "Raise the text to {valor} mm",
    fix_widenArc: "Widen the arc to {valor} mm radius",
    nudgeUp: "Move up one step",
    nudgeDown: "Move down one step",
    nudgeLeft: "Move left",
    nudgeRight: "Move right",
    nudgeHelp: "Fine adjustment. Tap the number to switch between 1 and 10 mm.",
    canvasLabel: "Design canvas",
    zones: "Zones on this garment",

    copyToZone: "Copy to {zona}",
    inkColor: "Ink colour",
    inks: "{n} inks",
    tooManyInks: "max {max}",
    screens: "{n} screen-print screens.",
    whiteBaseNeeded: "On a dark garment a white base is needed underneath: that is one more screen, included in the price.",
    pantoneNote: "On-screen colours are approximate. Ink is ordered by its reference.",
    view3d: "In 3D",
    downloadMockup: "Download the image",

    proofSheet: "Proof sheet (PDF)",
    downloadFailed: "The garment image could not be prepared.",
    mockupDisclaimer: "Indicative preview. It does not replace a printed proof.",
    templates: "Templates",
    templatesHelp: "A starting point you can change entirely.",

    templateInsert: "Insert with my details",
    group: "Group",
    ungroup: "Ungroup",
    copyDesign: "Copy to another garment",
    copyDesignDone: "Design copied. Open it on the other garment.",
    bringDesign: "You copied the design from {producto} · {zona}.",
    bringDesignAction: "Bring it here",
    bringDesignDone: "bring the design from another garment",
    myImages: "My images",
    reuseImage: "You uploaded these before; reuse them without hunting for the file.",
    ratioLocked: "Ratio locked",
    ratioFree: "Ratio free",
    alignTools: "Align",
    distributeH: "Distribute horizontally",
    distributeV: "Distribute vertically",
    alignTop: "Top",
    alignMiddle: "Middle",
    alignBottom: "Bottom",
    selectedCount: "{n} layers selected",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    zoomFit: "Fit to zone",
    zoomReset: "Actual size",
    weight: "Weight",
    weightNormal: "Regular",
    weightBold: "Bold",
    weightBlack: "Black",
    italic: "Italic",
    align: "Alignment",
    align_left: "Left",
    align_center: "Center",
    align_right: "Right",
    align_justify: "Justified",
    textCase: "Letter case",
    case_none: "Original",
    case_upper: "UPPER",
    case_lower: "lower",
    arc: "Arc",
    arcHint: "Curves the text, like on a crest.",
    arc_none: "Straight",
    arc_up: "Upwards",
    arc_down: "Downwards",
    outline: "Outline",
    outlineHint: "Needed when the text does not contrast with the garment.",
    fontGroup: { neutra: "Neutral", condensada: "Condensed", impacto: "Display", serif: "Serif", manuscrita: "Script", redondeada: "Rounded", decorativa: "Decorative" },
    undo: 'Undo',
    redo: 'Redo',
    viewFlat: 'Flat',
    viewGarment: 'On the garment',

    viewWorn: "On a model",
    layers: 'Layers',
    layer: 'Layer',
    properties: 'Properties',
    position: 'Position',
    size: 'Size',
    rotation: 'Rotation',
    opacity: 'Opacity',
    color: 'Colour',
    font: 'Font',
    textContent: 'Text',
    delete: 'Delete layer',
    duplicate: 'Duplicate',
    lock: 'Lock',
    unlock: 'Unlock',
    bringForward: 'Bring forward',
    sendBackward: 'Send backward',
    center: 'Centre',
    fitZone: 'Fit to area',
    zoneOutline: 'Print area',
    saving: 'Saving...',
    saved: 'Saved',
    saveError: 'Could not save',
    conflict: 'Someone else edited this design',
    conflictHelp: 'You opened the design in another tab. Reload to see the current version; your work is not lost.',
    mmUnit: 'mm',
    price: 'Price',
    checkout: 'Continue',
    emptyDesign: 'Add an image or some text to start.',

    contrastTitle: "Something will not show",

    contrastBody: "A layer is almost the same colour as the garment: once printed it will barely show.",

    contrastFix: "Switch to a visible colour",
    uploadHint: 'JPG, PNG, WEBP or SVG. Max {mb} MB.',
    photoWarning: 'If you upload a photo with people, we need their consent.',
  },
  diagnostics: {
    title: 'Technical review',
    none: 'Ready for production.',
    errors: '{count} issues blocking production',
    warnings: '{count} warnings',
    estimated: 'estimated measurement',
    codes: {
      LAYER_OUTSIDE_ZONE: 'The layer sticks out {measured} mm from the print area.',
      LAYER_OUTSIDE_CANVAS: 'The layer falls outside the visible area.',
      DESIGN_AREA_EXCEEDED: 'The design covers {measured} mm² and the maximum is {expected} mm².',
      ZONE_TECHNIQUE_NOT_ALLOWED: 'This area does not allow the chosen technique.',
      EFFECTIVE_DPI_TOO_LOW: 'The image resolves at {measured} dpi and {expected} are required. Use a larger image or scale it down.',
      IMAGE_UPSCALED: 'The image is being enlarged: it will lose sharpness.',
      TOO_MANY_INKS: 'There are {measured} inks and the maximum is {expected}.',
      GRADIENT_NOT_ALLOWED: 'This technique cannot reproduce photographs or gradients.',
      TECHNICAL_WHITE_NOT_AVAILABLE: 'This technique cannot print a white underbase.',
      COLOR_TYPE_NOT_SUPPORTED: 'That colour type cannot be produced with this technique.',
      STROKE_TOO_THIN: 'The stroke is {measured} mm and the minimum is {expected} mm.',
      ARC_OVERLAP: "The arced text wraps more than once and the letters overlap. Increase the radius or shorten the text.",
      TEXT_TOO_SMALL: 'The text is {measured} mm and the minimum is {expected} mm.',
      TEXT_NOT_FROZEN: 'The text will be frozen before production.',
      GEOMETRY_ESTIMATED: 'This layer is measured approximately until the text is frozen.',
      SUBSTRATE_NOT_SUPPORTED: 'This garment material does not support the chosen technique.',
      EXTERNAL_DIGITIZING_REQUIRED: 'Embroidery needs digitising first; it is included in the quote.',
      EMPTY_DESIGN: 'The design is empty.',
      LAYER_LIMIT_EXCEEDED: 'There are {measured} layers and the maximum is {expected}.',
    },
  },
  pricing: {
    title: 'Price',
    breakdown: 'Breakdown',
    subtotal: 'Net',
    vat: 'VAT',
    total: 'Total',
    quantity: 'Units',
    validUntil: 'Valid until {date}',
    expired: 'This quote has expired. We will recalculate it.',
    recalculate: 'Recalculate',
    concepts: {
      PRODUCT_BASE: 'Garment {sku}',
      SETUP: 'Order setup',
      SETUP_PER_INK: 'Setup per ink ({inks} inks)',
      UNIT_MARKING: 'Marking per unit',
      PER_INK_UNIT: 'Ink surcharge ({inks})',
      PER_PASS_UNIT: 'Pass surcharge ({passes})',
      SURCHARGE: 'Surcharge {surcharge}',
      MINIMUM_ORDER_ADJUSTMENT: 'Minimum order adjustment',
    },
    surcharges: {
      LARGE_AREA: 'for large area',
      DARK_GARMENT_WHITE_BASE: 'for white underbase on dark garment',
    },
  },
  checkout: {
    title: 'Complete order',
    sizes: 'Sizes and quantities',
    addSize: 'Add size',
    wallet: 'Besbello wallet',
    walletBalance: 'Available balance: {amount}',
    walletUse: 'Pay with balance',
    walletNone: 'You have no loyalty card linked.',
    terms: 'I accept the terms and conditions',
    marketing: 'I want to receive news and offers (optional)',
    confirm: 'Confirm order',
    decision: {
      PAYMENT: 'You can pay now',
      MANUAL_QUOTE: 'This order is reviewed by a person',
      WITHIN_THRESHOLDS: 'Amount and quantity fall within direct payment.',
      TOTAL_ABOVE_THRESHOLD: 'The amount exceeds the direct payment limit.',
      QTY_ABOVE_THRESHOLD: 'The quantity exceeds the direct payment limit.',
      TECHNIQUE_REQUIRES_QUOTE: 'This technique needs commercial review.',
      DESIGN_HAS_BLOCKING_DIAGNOSTICS: 'The design has unresolved technical issues.',
      QUOTE_EXPIRED: 'The quote has expired.',
    },
  },
  orders: {
    repeat: "Order again",
    title: 'My orders',
    empty: 'You have no orders yet.',
    reference: 'Reference',
    status: 'Status',
    total: 'Total',
    date: 'Date',
    detail: 'View order',
    cancel: 'Cancel order',
    statuses: {
      DRAFT: 'Draft',
      AWAITING_PAYMENT: 'Awaiting payment',
      PAID: 'Paid',
      IN_PRODUCTION: 'In production',
      READY: 'Ready for pickup',
      DELIVERED: 'Delivered',
      CANCELLED: 'Cancelled',
      REFUNDED: 'Refunded',
      QUOTE_REQUESTED: 'Quote requested',
    },
  },
  admin: {
    title: 'Administration',
    catalog: 'Catalogue',
    calibration: 'Calibration',
    exceptions: 'Exceptions',
    sampling: 'Sampling',
    pricing: 'Price books',
    workshop: 'Workshop',
    kpi: {
      title: 'Indicators',
      coverage: 'Catalogue coverage',
      skusPerHour: 'SKUs per person-hour',
      samplingError: 'Error rate found in sampling',
      openExceptions: 'Open exceptions',
      reviewed: 'Reviewed',
    },
    calibrator: {
      title: 'Print area calibrator',
      help: 'Drag the vertices to adjust the area over the photo. Measurements are in real millimetres.',
      confirm: 'Confirm correction',
      confirmHelp: 'A confirmed correction survives catalogue re-imports.',
      provenance: 'Provenance',
      trace: 'How it was resolved',
    },
    import: {
      title: 'Import catalogue',
      dryRun: 'Dry run',
      run: 'Import',
      added: 'Added',
      updated: 'Updated',
      retired: 'Retired',
      conflicts: 'Clashes with manual corrections',
    },
  },
  rgpd: {
    title: 'Data and privacy',
    consents: 'Consents',
    marketing: 'Marketing communications',
    photoUpload: 'Photos with people',
    export: 'Download my data',
    erase: 'Request erasure',
    requests: 'My requests',
    photoNotice:
      'If the image you upload has recognisable people, it is personal data. We need their consent and you can withdraw it at any time.',
  },





















  equipo: {





















    titulo: "Team",





















    ayuda: "Paste the club list: one line per person («Aitor 10 M», or comma-separated). Each member is validated with their name in place.",





















    sinRoles: "First mark which text is the name and which the number, in the layer properties.",





















    cargar: "Load list",





















    nombre: "Name",





















    dorsal: "Number",





















    talla: "Size",





















    estado: "Status",





















    noCabe: "does not fit",





















    guardar: "Save roster ({n})",





















    guardadoOk: "Roster saved.",





















    conProblemas: "{n} with issues",





















    rolCampo: "Team role",





















    rolLibre: "Free text",





















  },





















  template: {
    farewell: "Farewell",

    crew: "Festival crew",

    anniversary: "Anniversary",

    grandpa: "Grandma/pa",

    backNumber: "Back number",

    pet: "Pet",

    kidBirthday: "Kids birthday",

    localShop: "Local business",

    field: {

      teamName: "Team name",

      number: "Number",

      crewName: "Crew name",

      year: "Year",

      years: "Years",

      name: "Name",

      who: "Grandma or grandpa?",

      playerName: "Player name",

      petName: "Pet name",

      businessName: "Business name",

      since: "Since (year)",

    },
    team: "Team",
    company: "Company",
    event: "Event",
    birthday: "Birthday",
  },
  templateCat: {
    grupo: "Group",
    empresa: "Company",
    evento: "Event",
    deporte: "Sport",
  },
  shape: {
    rectangulo: "Rectangle",
    "rectangulo-redondeado": "Rounded",
    circulo: "Circle",
    linea: "Line",
    triangulo: "Triangle",
    estrella: "Star",
    poligono: "Polygon",
    corazon: "Heart",
    flecha: "Arrow",
    escudo: "Crest",
    banderola: "Banner",
  },
  designs: {
    title: "My designs",
    empty: "You have not started any design yet.",
    browse: "Browse the catalogue",
    layers: "{n} elements",
    expiresIn: "expires in {n} days",
  },
  shared: {
    gone: "This link is no longer valid",
    noDesign: "This design is empty.",
    readOnly: "Indicative, read-only preview. It does not replace a printed proof.",
    expires: "The link is valid until {fecha}.",
  },
};
